module.exports = __webpack_public_path__ + "img/003.65660f64.png";